export default __webpack_public_path__ + "static/media/alarm-definite-called-open.902dbe25.mp3";